var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info"},[_c('fa',{attrs:{"icon":"spinner","spin":""}}),_vm._v(" "),_vm._t("default",[_vm._v("Loading...")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }